"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledIcon = exports.OverflowGroupMenuItem = exports.OverflowGroupMenu = exports.OverflowGroupButton = void 0;
var _Menu = _interopRequireDefault(require("../Menu"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Button = _interopRequireDefault(require("../Button"));
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var OverflowGroupButton = exports.OverflowGroupButton = (0, _ykbStyledComponents.default)(_Button.default).withConfig({
  componentId: "ykb-ui__sc-t9hvyv-0"
})(["float:", ";", " ", ""], function (_ref) {
  var $align = _ref.$align;
  return $align;
}, function (props) {
  return props.size === 'small' && (0, _ykbStyledComponents.css)(["padding:", ";font-size:", ";font-weight:", ";height:", ";"], function (props) {
    return props.theme.button.size.small.padding;
  }, function (props) {
    return props.theme.button.size.small.fontSize;
  }, function (props) {
    return props.theme.button.size.small.fontWeight;
  }, function (props) {
    return props.theme.button.size.small.height;
  });
}, function (props) {
  return props.size === 'large' && (0, _ykbStyledComponents.css)(["padding:", ";font-size:", ";font-weight:", ";height:", ";"], function (props) {
    return props.theme.button.size.large.padding;
  }, function (props) {
    return props.theme.button.size.large.fontSize;
  }, function (props) {
    return props.theme.button.size.large.fontWeight;
  }, function (props) {
    return props.theme.button.size.large.height;
  });
});
var OverflowGroupMenu = exports.OverflowGroupMenu = (0, _ykbStyledComponents.default)(_Menu.default).withConfig({
  componentId: "ykb-ui__sc-t9hvyv-1"
})(["border:none;.OverflowGroup-Dropdown-menu-item:hover .ykb-button{text-decoration:underline;}.OverflowGroup-Dropdown-menu-item .ykb-button{padding:8px 10px;}"]);
var OverflowGroupMenuItem = exports.OverflowGroupMenuItem = (0, _ykbStyledComponents.default)(_Menu.default.Item).withConfig({
  componentId: "ykb-ui__sc-t9hvyv-2"
})(["&&.OverflowGroup-Dropdown-menu-item{padding:0px;}"]);
var StyledIcon = exports.StyledIcon = (0, _ykbStyledComponents.default)(_Icon.default).withConfig({
  componentId: "ykb-ui__sc-t9hvyv-3"
})(["margin-left:5px;transform-origin:50% 50%;transition:transform 0.2s ease;&.rotate{transform:rotate(180deg);}"]);